import { render, staticRenderFns } from "./AddTournamentTeamCard.vue?vue&type=template&id=311bb34e&scoped=true"
import script from "./AddTournamentTeamCard.vue?vue&type=script&lang=js"
export * from "./AddTournamentTeamCard.vue?vue&type=script&lang=js"
import style0 from "./AddTournamentTeamCard.vue?vue&type=style&index=0&id=311bb34e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311bb34e",
  null
  
)

export default component.exports